/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './cta-section';
import '../button-group/index';
import '../cta/button-cta';
import '../cta/text-cta';
import '../cta-block/cta-block';
import '../cta-block/cta-block-item-row';
import '../cta-block/cta-block-item';
import '../content-item/index';
import '../content-block/content-block-heading';
import '../content-block/content-block-copy';
